var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22373",
    "data-name": "Group 22373",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.52,
    height: 23.481,
    viewBox: "0 0 23.52 23.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9116",
    "data-name": "Rectangle 9116",
    width: 23.52,
    height: 23.481,
    fill: "#fbb516"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22372",
    "data-name": "Group 22372",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42252",
    "data-name": "Path 42252",
    d: "M23.52,11.008v1.467c-.013.059-.03.118-.039.177-.08.543-.13,1.092-.242,1.629A11.753,11.753,0,0,1,13.808,23.3c-.436.071-.876.121-1.314.181h-1.47c-.051-.012-.1-.029-.154-.037-.537-.078-1.078-.13-1.609-.236a11.75,11.75,0,0,1-9.078-9.4c-.072-.443-.123-.89-.184-1.335V11.008c.014-.074.028-.148.041-.222.134-.75.2-1.518.412-2.247A11.756,11.756,0,0,1,23.341,9.718c.072.428.12.86.178,1.29m-1.378.729A10.382,10.382,0,1,0,11.758,22.1,10.388,10.388,0,0,0,22.141,11.738",
    transform: "translate(0 0.001)",
    fill: "#fbb516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42253",
    "data-name": "Path 42253",
    d: "M154.7,112.164a3,3,0,0,1-1.686,2.761,2.745,2.745,0,0,1-1.282.306.687.687,0,1,1-.036-1.374,1.606,1.606,0,0,0,1.615-1.713c0-2.636,0-5.273,0-7.909a3.193,3.193,0,0,1,3.251-3.211,3.06,3.06,0,0,1,2.8,1.722,3.1,3.1,0,0,1-.195,3.3c-.037.058-.079.112-.128.182a3.672,3.672,0,0,1,1.605,2.808,3.587,3.587,0,0,1-.751,2.465,3.708,3.708,0,0,1-5.2.661m-.011-5.4c0,.557,0,1.115,0,1.672a9.03,9.03,0,0,0,.043,1.21,2.266,2.266,0,0,0,2.124,1.912,2.292,2.292,0,0,0,1.209-4.31.452.452,0,0,0-.407-.027,4.168,4.168,0,0,1-.708.178.688.688,0,1,1-.21-1.348,1.835,1.835,0,1,0-2.05-1.829c-.008.848,0,1.7,0,2.543",
    transform: "translate(-144.081 -96.383)",
    fill: "#fbb516"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeta);
export default __webpack_public_path__ + "static/media/icon-beta.422fdc4708a67bc9506a1ae208882f29.svg";
export { ForwardRef as ReactComponent };